(function () {
    const scriptSrc = document.currentScript.getAttribute('data-section');
    const infoIconSlider = () => {
        var current_section = window.document.querySelector('[id$="' + scriptSrc + '"]');
        var columnsCarousel = current_section.querySelector('.info-icon-slider__carousel');
        if (!columnsCarousel) {
            return;
        }

        let flkty = new Flickity(columnsCarousel, {
            cellAlign: 'left',
            contain: true,
            pageDots: true,
            prevNextButtons: false,
            groupCells: '100%',
            arrowShape: {
                x0: 10,
                x1: 60,
                y1: 50,
                x2: 60,
                y2: 40,
                x3: 20
            },
        });
    };

    window.addEventListener('load', function () {
        infoIconSlider();
    });
})();